module.exports = __webpack_public_path__ + "img/swiper7.6658b8c5.png";